import Decimal from 'decimal.js';

const isPositionLong = (positionSize: CurrencyAmount) => (new Decimal(positionSize).isPositive());

export default isPositionLong;
